import { LinkCategoriesTable } from "components";

const LinkCategories = () => {
    return (
        <LinkCategoriesTable />
    );
};

export default LinkCategories;
